const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');

/** Builds the TypeBox schema fragment for the ReadOnlyDateTime form element. */
function asDataDictionary(hNode, context) {
    const { id, title, propertyName } = hNode;
    //This block tells us nothing about namespaces/relations
    const subDataDictionary = {};

    const { schemaOptions } = moduleRegistration.resolveFieldFlags(false, { ...context, readOnly: true });
    const stringOptions = {
        title: title,
        format: 'date-time',
        'x-id': id,
        'x-dataType': 'string',
        'x-propertyName': propertyName,
        ...schemaOptions,
        readOnly: true
    };

    const readOnlyDateTimeSchema = Type.Optional(Type.String(stringOptions));

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
        [propertyName]: readOnlyDateTimeSchema
    };

    return [subDataDictionary, partialTypeDefinition];
}

module.exports = { asDataDictionary };
